"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const noop_1 = __importDefault(require("lodash/noop"));
function useTimeout({ time = 0, callback, ignoreZeroTime = false }) {
    const ignoreTimeout = time === 0 && ignoreZeroTime;
    const timeoutId = (0, react_1.useRef)(null);
    const cancelTimeout = (0, react_1.useCallback)(() => {
        if (!timeoutId.current) {
            return;
        }
        clearTimeout(timeoutId.current);
    }, [timeoutId]);
    (0, react_1.useEffect)(() => {
        if (ignoreTimeout) {
            return;
        }
        timeoutId.current = setTimeout(callback, time);
        return () => {
            clearTimeout(timeoutId.current);
        };
    }, [callback, time, timeoutId, ignoreTimeout]);
    if (ignoreTimeout) {
        return [noop_1.default];
    }
    return [cancelTimeout];
}
exports.default = useTimeout;
